/* All free solid fontawesome icons -> https://fontawesome.com/icons?d=gallery&s=solid&m=free */
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import {
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleDown,
    faAngleRight,
    faAngleUp,
    faArrowLeft,
    faArrowRight,
    faBars,
    faBell,
    faBookMedical,
    faBookOpen,
    faCalendar,
    faCalendarCheck,
    faCalendarDay,
    faCalendarTimes,
    faCalendarWeek,
    faCaretLeft,
    faCaretRight,
    faChalkboard,
    faChalkboardTeacher,
    faChartArea,
    faChartBar,
    faChartPie,
    faCheck,
    faCheckCircle,
    faChevronDown,
    faChevronRight,
    faChevronUp,
    faClinicMedical,
    faClipboardList,
    faClock,
    faClone,
    faCogs,
    faColumns,
    faCopy,
    faCropAlt,
    faDollarSign,
    faDove,
    faEdit,
    faEraser,
    faExclamation,
    faExclamationCircle,
    faExclamationTriangle,
    faExternalLinkAlt, faEye, faEyeSlash, faFileAlt, faFileArchive, faFileCode,
    faFileInvoiceDollar,
    faFilter,
    faFlag,
    faHandHoldingUsd,
    faHospitalAlt,
    faHospitalUser,
    faIdCard,
    faInfo,
    faInfoCircle,
    faLaptopMedical,
    faLink,
    faLongArrowAltRight,
    faMapMarked,
    faMapMarkedAlt,
    faMapMarker,
    faMapMarkerAlt,
    faMapPin,
    faMarker,
    faMicrophone,
    faMicrophoneSlash,
    faMoneyCheck,
    faMoneyCheckAlt,
    faMousePointer,
    faPercentage, faPhone,
    faPhoneAlt,
    faPhoneSlash,
    faPhoneSquareAlt,
    faPlus,
    faPlusCircle,
    faPrint,
    faProcedures,
    faRedo,
    faReply,
    faRetweet,
    faSearch,
    faShare,
    faShareAlt,
    faShareSquare,
    faShieldAlt,
    faSignInAlt,
    faSpinner,
    faStopwatch,
    faStopwatch20,
    faSync,
    faTable,
    faTachometerAlt,
    faTag, faTags,
    faThList,
    faTimes,
    faTrash,
    faTrashAlt,
    faUndo,
    faUser,
    faUserCog,
    faUserEdit,
    faUserMd,
    faUsersCog,
    faVideo,
    faVideoSlash,
    faVolumeMute,
    faVolumeUp,
    faCheckDouble,
    faFileShield,
    faTimeline, faDatabase, faBrain, faDownload
} from '@fortawesome/free-solid-svg-icons'

export const fontAwesomeSolidIcons = {
    faPhoneSquareAlt,
    faAngleDown,
    faAngleRight,
    faArrowLeft,
    faArrowRight,
    faBars,
    faSignInAlt,
    faBookOpen,
    faChartArea,
    faChartBar,
    faChartPie,
    faChevronDown,
    faChevronRight,
    faWhatsapp,
    faChevronUp,
    faColumns,
    faDollarSign,
    faExclamation,
    faExclamationTriangle,
    faFlag,
    faLongArrowAltRight,
    faMousePointer,
    faPercentage,
    faPlus,
    faPlusCircle,
    faSearch,
    faTable,
    faTachometerAlt,
    faTag,
    faUser,
    faBookMedical,
    faHandHoldingUsd,
    faFileInvoiceDollar,
    faHospitalUser,
    faThList,
    faUserEdit,
    faIdCard,
    faProcedures,
    faHospitalAlt,
    faSpinner,
    faCalendarDay,
    faCalendar,
    faCalendarCheck,
    faCalendarWeek,
    faCogs,
    faClock,
    faStopwatch20,
    faStopwatch,
    faRetweet,
    faSync,
    faTimes,
    faCalendarTimes,
    faAngleDoubleRight,
    faReply,
    faUserMd,
    faAngleDoubleLeft,
    faEdit,
    faLink,
    faMoneyCheckAlt,
    faMoneyCheck,
    faTrash,
    faTrashAlt,
    faExternalLinkAlt,
    faFilter,
    faPrint,
    faCheckCircle,
    faMarker,
    faMapMarkerAlt,
    faUserCog,
    faUsersCog,
    faMapPin,
    faMapMarker,
    faMapMarkedAlt,
    faMapMarked,
    faClone,
    faCopy,
    faAngleUp,
    faEraser,
    faPhoneAlt,
    faClinicMedical,
    faClipboardList,
    faExclamationCircle,
    faInfo,
    faVideo,
    faVideoSlash,
    faShieldAlt,
    faLaptopMedical,
    faPhoneSlash,
    faVolumeMute,
    faVolumeUp,
    faShare,
    faCaretLeft,
    faCaretRight,
    faDove,
    faMicrophone,
    faMicrophoneSlash,
    faChalkboard,
    faChalkboardTeacher,
    faBell,
    faInfoCircle,
    faShareAlt,
    faUndo,
    faRedo,
    faCropAlt,
    faCheck,
    faShareSquare,
    faTags,
    faEye,
    faEyeSlash,
    faFileCode,
    faPhone,
    faFileArchive,
    faFileAlt,
    faCheckDouble,
    faFileShield,
    faTimeline,
    faDatabase,
    faBrain,
    faDownload
}
